let time = $('#active-count-down').data('time');
$(`#active-count-down`).timeTo({
    timeTo: new Date(time),
    theme: "black",
    displayDays: 2,
    displayCaptions: true,
    fontSize: !isMobile() ? 26 : 18,
    captionSize: !isMobile() ? 14 : 13,
    lang: 'en',
    countdown: true,
    languages: {
      en: {
        days: 'DAY',
        hours: 'HRS',
        min: 'MIN',
        sec: 'SEC',
      }
      
    }
});


// $('.active-add-cart-btn').on('click', function (e) {
//     let id = $(this).data('variantid') || $(this).data('id');
//     addCartFn(id)
// })

$('.product-add-cart-botton').on('click', function (e) {
    let id = $(this).data('variantid') || $(this).data('id');
    addCartFn(id)
})



$('.subscribe-input-append').on('click', function (e) {
    let email = $('.subscriber-email').val();
    if (email) {
        $.ajax({
            url: 'https://backend.turboant.com/index/api/dealshopifycustomer',
            type: 'post',
            data: {
                account: 'turboant.myshopify.com',
                email: $('.subscriber-email').val()
            },
            dataType: 'json',
            success: (res) => {
                const { status, msg } = res;
                if (status === 1) {
                    $('.subscribe-card').append(`<div class='tb-toast'>Subscribe to the success!</div>`);
                    setTimeout(function () {
                        $('.tb-toast').remove();
                    }, 1000)
                } else {
                    $('.subscribe-card').append(`<div class='tb-toast'>${msg}</div>`);
                    setTimeout(function () {
                        $('.tb-toast').remove();
                    }, 1000)
                }
            }
        });
    } else {
        $('.subscribe-card').append(`<div class='tb-toast'>E-mail is required!!!</div>`);
        setTimeout(function () {
            $('.tb-toast').remove();
        }, 1000)
    }

});

var pageAnchorswiper = new Swiper(".pageAnchorSwiper", {
    slidesPerView: 4,
    spaceBetween: 48,
    on: {
        init: function () {
            if ($(window).width() <= 768) {
                this.params.spaceBetween = 12;
                this.params.slidesPerView = 2;
                this.params.centeredSlides = true;
                this.update();
            }
        },
        resize: function (swiper) {
            if ($(window).width() <= 768) {
                this.params.spaceBetween = 12;
                this.params.slidesPerView = 2;
                this.params.centeredSlides = true;
                this.update();
            }
        }
    }
});

//定时
setTimeout(() => {
    pageAnchorswiper.slideTo(1, 50, false);
}, 50);


// let scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'
// if (window.ShopifyBuy) {
//   if (window.ShopifyBuy.UI) {
//     ShopifyBuyInit();
//   } else {
//     loadScript();
//   }
// } else {
//   loadScript();
// }

// function loadScript() {
//   var script = document.createElement('script');
//   script.async = true;
//   script.src = scriptURL;
//   (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
//   script.onload = ShopifyBuyInit;
// }

// function ShopifyBuyInit() {
//     var client = ShopifyBuy.buildClient({
//       domain: 'turboant.com',
//       storefrontAccessToken: 'b0f1bb69a767b8a384e7c94ddd6e7f8a',
//     });
//     let presellProduct = document.querySelectorAll('.presell-checkout-btn');
//     presellProduct.forEach(item => {
//       let id = $(item).data('productid');
//       let checkoutBtn = $(item).data('btn');
//       ShopifyBuy.UI.onReady(client).then(function (ui) {
//         console.log(id, checkoutBtn)
//         ui.createComponent('product', {
//           id: id,
//           node: document.getElementById(`product-component-${id}`),
//           moneyFormat: '%24%7B%7Bamount%7D%7D',
//           options: {
//             "product": {
//               iframe: false,
//               "buttonDestination": "checkout",
//               "contents": {
//                 "img": false,
//                 "title": false,
//                 "price": false
//               },
//               "classes": {
//                 button: "presell-checkout"
//               },
//               "text": {
//                 "button": checkoutBtn
//               }
//             }
//           }
//         });
//       });
//     })
  
//   }

$('.active-checkout-btn').click(function () {
  const variantId = $(this).data('variantid');
  
  const mutation = `
    mutation {
      cartCreate(
        input: {
          lines: [
            {
              quantity: 1
              merchandiseId: "gid://shopify/ProductVariant/${variantId}"
            }
          ]
        }
      ) {
        cart {
          id
          checkoutUrl
        }
      }
    }
  `;

  fetch('/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'b0f1bb69a767b8a384e7c94ddd6e7f8a'
    },
    body: JSON.stringify({ query: mutation })
  })
  .then(response => response.json())
  .then(result => {
    if (result.data && result.data.cartCreate && result.data.cartCreate.cart) {
      window.location.href = result.data.cartCreate.cart.checkoutUrl;
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
});